import React, { useMemo } from 'react';

import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';

import ModalBox from 'components/application/ModalBox';

import AttachmentDisplay from 'components/attachments/components/AttachmentDisplay';
import Download from 'components/attachments/components/Download';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function AttachmentPreviewer({ attachment, onClose }) {
  const timestamp = useMemo(
    () => moment().unix(),
    [JSON.stringify(attachment)],
  );

  return (
    <ModalBox isOpen={true} onClose={onClose}>
      <div className='tw-border-b tw-border-grey-100 tw-px-6'>
        <div className='tw-flex tw-items-center tw-justify-between'>
          <h2 className='tw-text-lg tw-mr-4 tw-w-90 tw-truncate tw-font-semibold'>
            {attachment.attributes.filename}
          </h2>
          <Download
            disabled={!attachment.attributes.attachedUrl}
            filename={attachment.attributes.filename}
            hashid={attachment.attributes.hashid}
          />
        </div>
      </div>
      <div
        className={classNames(
          'tw-overflow-auto tw-py-2',
          attachment.attributes.recordType === 'pdf' && 'tw-p-0',
        )}
      >
        <AttachmentDisplay
          attachedUrl={attachment.attributes.attachedUrl}
          recordType={attachment.attributes.recordType}
          timestamp={timestamp}
        />
      </div>
    </ModalBox>
  );
}

AttachmentPreviewer.propTypes = {
  attachment: resourceShape('attachment').isRequired,
  onClose: PropTypes.func.isRequired,
};
